export function validateAlphabets(inputValue: any): boolean {
  return /^[a-z]+$/i.test(inputValue);
}

export function validateNotEmpty(inputValue: any): boolean {
  if (typeof inputValue === 'object') {
    return inputValue !== null && Boolean(inputValue.length);
  }
  return Boolean(inputValue) && inputValue.toString().trim() !== '';
}

// Validation based on this: https://help.sap.com/docs/SAP_EMARSYS/f8e2fafeea804018a954a8857d9dfff3/fdecf5bb74c11014b59cc2760245a63e.html?q=Incorrect+syntax+email&locale=en-US
export function validateEmail(inputValue: string): boolean {
  const regex =
    /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z][a-zA-Z.]*[a-zA-Z]$/;
  /**
   * /[^\x20-\x7E]/ — rejects any non-printable-ASCII character anywhere (emojis, accented letters, CJK, Cyrillic, etc.), catches anything that bypasses the regex (e.g., copy-paste, programmatic input)
   * @.*xn--/ — rejects Punycode-encoded domains that browsers auto-generate from non-ASCII input via type="email"
   */
  return regex.test(inputValue) && !/[^\x20-\x7E]/.test(inputValue) && !/@.*xn--/i.test(inputValue);
}

export function validatePhone(inputValue: string): boolean {
  return /^\+?[\d\s\-()/]{7,}$/.test(inputValue);
}
